import React, {useState} from 'react';
import RLookUpModal from "./RLookUpModal";

const MyComponent = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {
  const [isOpen, setIsOpen] = useState(false)
  const myHandler = (isOpen) => {
    setTimeout(() => {
      setIsOpen(isOpen);
    }, 100)
  }
  return (
    <div
      onClick={() => setIsOpen(true)}
      className={"d-flex justify-content-center align-items-center btn btn__secondary_purple"}>
      <div>
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               className="bi bi-person-square" viewBox="0 0 16 16">
            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
            <path
              d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1v-1c0-1-1-4-6-4s-6 3-6 4v1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12z"/>
          </svg>
        </>

        <span className={"px-2"}>
          {sendData.currentSelectedOrganizeName}
          </span>
      </div>

      {isOpen && <RLookUpModal
        id={initialData.memberRLookUpId}
        callBackDataHandler={(incomingData) => {
          // alert(incomingData)
          console.log(incomingData)

          setSendData({
            memberId: incomingData.na_996, currentSelectedOrganizeName: incomingData.na_997
          })
        }}
        modalHandler={[isOpen, myHandler]}
        variables={JSON.stringify({na_1222:sendData.customerId})}
        variableIsStringify={true}
      />}
    </div>
  );
};

export default MyComponent;
